import { useMemo } from 'react'
import { Cell, Column } from 'react-table'

import { TableWithPaginationWrapper } from 'components/Table/styles'
import { DomainType } from 'features/domains/types'
import { Table } from 'components/Table'
import ReviewDealerMobile from './ReviewDealerMobile'
import ReviewDealerNameCell from './ReviewDealerNameCell'
import { ReclaimLicenseTableWrapper } from '../styles'
import ReviewDealerEmailCell from './ReviewDealerEmailCell'

interface ReviewDealerTableProps {
  dealers: DomainType[]
}

/**
 * @todo localization
 */

function ReviewDealerTable({ dealers }: ReviewDealerTableProps) {
  const headers = useMemo(
    () => ({
      name: {
        label: 'Name',
        id: 'name',
      },
      phone: {
        label: 'Phone',
        id: 'phone',
      },
      email: {
        label: 'Email',
        id: 'email',
      },
    }),
    []
  )

  const columns: readonly Column<DomainType>[] = useMemo(
    () => [
      {
        Header: headers.name.label,
        id: headers.name.id,
        accessor: 'name',
        Cell: (cell: Cell<DomainType>) => (
          <ReviewDealerNameCell dealer={cell.row.original} />
        ),
        percentWidth: '50%',
      },
      {
        Header: headers.phone.label,
        id: headers.phone.id,
        accessor: 'phone',
        percentWidth: '25%',
      },
      {
        Header: headers.email.label,
        id: headers.email.id,
        accessor: 'email',
        percentWidth: '25%',
        Cell: (cell: Cell<DomainType>) => (
          <ReviewDealerEmailCell email={cell.value} />
        ),
      },
    ],
    [headers]
  )

  return (
    <TableWithPaginationWrapper>
      <ReclaimLicenseTableWrapper>
        <Table
          columns={columns}
          data={dealers}
          mobileViewComponent={ReviewDealerMobile}
          disableSortBy
        />
      </ReclaimLicenseTableWrapper>
    </TableWithPaginationWrapper>
  )
}

export default ReviewDealerTable
